import { render, staticRenderFns } from "./ScriptsForm.vue?vue&type=template&id=be759cf0&scoped=true&"
import script from "./ScriptsForm.vue?vue&type=script&lang=js&"
export * from "./ScriptsForm.vue?vue&type=script&lang=js&"
import style0 from "./ScriptsForm.vue?vue&type=style&index=0&id=be759cf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be759cf0",
  null
  
)

export default component.exports